module.exports = "/_next/static/images/Hero@2x-da52f982e522efcd36fd9ffeb1962083.webp";